import propTypes from 'prop-types';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Moment from 'react-moment';
import { connect } from 'react-redux';

const FeedbackItem = ({
    auth,
    feedback: { _id, stars, name, feedbacktext, email, date },
}) => {

return (
    <Col>
        <Card border='warning'>
            <Card.Header>
                Stars : {stars}
            </Card.Header>
            <Card.Body>
                {feedbacktext}
            </Card.Body>
            <Card.Footer>
            <table className='room-card-table'>
                <tbody>
                    <tr>
                        <td>
                            <tr><td>{<Moment format='YYYY/MM/DD'>{date}</Moment>}</td></tr>
                            <tr><td>{name}</td></tr>
                            <tr><td>{email}</td></tr>
                        </td>
                    </tr>
                </tbody>
            </table>
            </Card.Footer>
        </Card>
    </Col>
)};

FeedbackItem.propTypes = {
    feedback: propTypes.object.isRequired,
    auth: propTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {})(FeedbackItem);